import { toastError } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';
import baseApi from '@/store/api/baseApi';
import { Types } from '@/store/types';

export const myDashboardApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getProductList: builder.mutation({
			query: ({ params, body }) => ({
				url: '/product/search',
				method: 'POST',
				params,
				body
			})
		}),
		getTaskDashboardFilterById: builder.query({
			query: ({ id }) => ({
				url: `/task-dashboard-filter/${id}`,
				method: 'GET'
			})
		}),
		getFilterOptions: builder.mutation({
			query: ({ params, body }) => ({
				url: '/product/filter-options',
				method: 'POST',
				params,
				body
			}),
			async onQueryStarted(args, { queryFulfilled, dispatch }) {
				try {
					dispatch(openLoader());
					const { data } = await queryFulfilled;
					dispatch({
						type: Types.STORE_DEPENDENT_FILTER_LIST,
						payload: { responseData: data, filterListPage: 'PRODUCT_LIST' }
					});
				} catch (error) {
					toastError(error?.data?.message || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		})
	})
});

export const { useGetProductListMutation, useGetTaskDashboardFilterByIdQuery, useGetFilterOptionsMutation } =
	myDashboardApi;
